import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Grid } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";

import DashboardHeader from "./dashboardHeader";

export default function Dashboard({children}, ...props) {
    return (
        <div className="dashboard-main">
            <DashboardHeader/>
            <div className="dashboard-content">
                {children}
            </div>
        </div>
    )
}